import { DialogService } from './vscode/src/vs/workbench/services/dialogs/common/dialogService.js';
import { IDialogService, IFileDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { AbstractFileDialogService } from './vscode/src/vs/workbench/services/dialogs/browser/abstractFileDialogService.js';
import { FileDialogService } from './vscode/src/vs/workbench/services/dialogs/browser/fileDialogService.js';
import { unsupported } from './tools.js';
import './vscode/src/vs/workbench/browser/parts/dialogs/dialog.web.contribution.js';
import './vscode/src/vs/workbench/contrib/welcomeDialog/browser/welcomeDialog.contribution.js';

class DialogServiceOverride extends AbstractFileDialogService {
    constructor() {
        super(...arguments);
        this.pickWorkspaceAndOpen = unsupported;
    }
    async pickFileFolderAndOpen(options) {
        const schema = this.getFileSystemSchema(options);
        if (options.defaultUri == null) {
            options.defaultUri = await this.defaultFilePath(schema);
        }
        return super.pickFileFolderAndOpenSimplified(schema, options, false);
    }
    async pickFolderAndOpen(options) {
        const schema = this.getFileSystemSchema(options);
        if (options.defaultUri == null) {
            options.defaultUri = await this.defaultFolderPath(schema);
        }
        return super.pickFolderAndOpenSimplified(schema, options);
    }
    async pickFileAndOpen(options) {
        const schema = this.getFileSystemSchema(options);
        if (options.defaultUri == null) {
            options.defaultUri = await this.defaultFilePath(schema);
        }
        return super.pickFileAndOpenSimplified(schema, options, false);
    }
    async showSaveDialog(options) {
        const schema = this.getFileSystemSchema(options);
        return super.showSaveDialogSimplified(schema, options);
    }
    async showOpenDialog(options) {
        const schema = this.getFileSystemSchema(options);
        return super.showOpenDialogSimplified(schema, options);
    }
    async pickFileToSave(defaultUri, availableFileSystems) {
        const schema = this.getFileSystemSchema({ defaultUri, availableFileSystems });
        const options = this.getPickFileToSaveDialogOptions(defaultUri, availableFileSystems);
        return super.pickFileToSaveSimplified(schema, options);
    }
}
function getServiceOverride({ useHtmlFileSystemProvider = false } = {}) {
    return {
        [( IDialogService.toString())]: new SyncDescriptor(DialogService, undefined, true),
        [( IFileDialogService.toString())]: useHtmlFileSystemProvider ? new SyncDescriptor(FileDialogService, undefined, true) : new SyncDescriptor(DialogServiceOverride, undefined, true)
    };
}

export { getServiceOverride as default };
